/* tslint:disable */
/* eslint-disable */
/**
 * TRWL API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { SearchHitObject } from './search-hit-object';
// May contain unused imports in some cases
// @ts-ignore
import type { Suggest } from './suggest';

/**
 * 
 * @export
 * @interface SearchHitsObject
 */
export interface SearchHitsObject {
    /**
     * 
     * @type {Suggest}
     * @memberof SearchHitsObject
     */
    'suggest'?: Suggest;
    /**
     * 
     * @type {Array<SearchHitObject>}
     * @memberof SearchHitsObject
     */
    'searchHits'?: Array<SearchHitObject>;
    /**
     * 
     * @type {object}
     * @memberof SearchHitsObject
     */
    'aggregations'?: object;
    /**
     * 
     * @type {number}
     * @memberof SearchHitsObject
     */
    'maxScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchHitsObject
     */
    'totalHits'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchHitsObject
     */
    'pointInTimeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchHitsObject
     */
    'totalHitsRelation'?: SearchHitsObjectTotalHitsRelationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SearchHitsObject
     */
    'empty'?: boolean;
}

export const SearchHitsObjectTotalHitsRelationEnum = {
    EqualTo: 'EQUAL_TO',
    GreaterThanOrEqualTo: 'GREATER_THAN_OR_EQUAL_TO',
    Off: 'OFF'
} as const;

export type SearchHitsObjectTotalHitsRelationEnum = typeof SearchHitsObjectTotalHitsRelationEnum[keyof typeof SearchHitsObjectTotalHitsRelationEnum];


